export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const inputCls =
  "w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white placeholder:text-white/35 text-sm focus:outline-none focus:border-[#e2001a] focus:bg-white/10 transition-colors duration-200";

export const selectCls = `${inputCls} appearance-none cursor-pointer [&>option]:bg-[#1e2226]`;

export const eur = (n) =>
  `${Number(n || 0).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const dstr = (d) => (d ? new Date(d).toLocaleDateString("de-DE") : "–");

export const btnGhost =
  "inline-flex items-center gap-2 border border-white/25 hover:border-white px-4 py-2.5 rounded-xl text-sm font-display transition-colors";

export const btnRed =
  "inline-flex items-center gap-2 bg-[#e2001a] hover:bg-[#b80016] px-5 py-2.5 rounded-xl text-sm font-display font-semibold transition-colors";

export const vatLabel = (rate) => (rate ? `Mehrwertsteuer (${rate} %)` : "Mehrwertsteuer (steuerfrei, 0 %)");
